//  IDE/ide/help/javascript.ts
import { HelpCategory } from "./types";

// Liste complète par défaut — harmonisée snake_case
export const JS_HELP_ITEMS: HelpCategory[] = [
    {
        name: "Mouvement",
        color: "#1677ff",
        snippets: [
            // ======== GÉNÉRAL ========
            { id: "walk", label: "walk()", code: `walk();` },

            // ======== RELATIF ========
            {
                id: "walk_choice",
                label: "walk_choice(direction)",
                code: `// direction = "FORWARD" ou "BACKWARD"\nwalk_choice("FORWARD");`,
            },
            {
                id: "walk_choice_by_unit",
                label: "walk_choice_by_unit(direction, distance)",
                code: `// direction = "FORWARD" ou "BACKWARD"\nwalk_choice_by_unit("FORWARD", 5);`,
            },

            // ======== PAR ID ========
            {
                id: "walk_by_id",
                label: "walk_by_id(id, distance)",
                code: `walk_by_id("charId", 1);`,
            },

            // ======== AVANT / ARRIÈRE ========
            { id: "walk_forward", label: "walk_forward()", code: `walk_forward();` },
            { id: "walk_backward", label: "walk_backward()", code: `walk_backward();` },

            // ======== AXES CARDINAUX ========
            { id: "walk_up", label: "walk_up()", code: `walk_up();` },
            { id: "walk_down", label: "walk_down()", code: `walk_down();` },
            { id: "walk_left", label: "walk_left()", code: `walk_left();` },
            { id: "walk_right", label: "walk_right()", code: `walk_right();` },

            // ======== DIAGONALES ========
            { id: "walk_left_up", label: "walk_left_up()", code: `walk_left_up();` },
            { id: "walk_left_down", label: "walk_left_down()", code: `walk_left_down();` },
            { id: "walk_right_up", label: "walk_right_up()", code: `walk_right_up();` },
            { id: "walk_right_down", label: "walk_right_down()", code: `walk_right_down();` },

            // ======== JUMP ========
            { id: "jump", label: "jump()", code: `jump();` },
            {
                id: "jump_choice",
                label: "jump_choice(direction)",
                code: `// direction = "FORWARD" ou "BACKWARD"\njump_choice("FORWARD");`,
            },
            {
                id: "jump_choice_by_unit",
                label: "jump_choice_by_unit(direction, distance)",
                code: `// direction = "FORWARD" ou "BACKWARD"\njump_choice_by_unit("BACKWARD", 3);`,
            },
            { id: "jump_forward", label: "jump_forward()", code: `jump_forward();` },
            { id: "jump_backward", label: "jump_backward()", code: `jump_backward();` },
            { id: "jump_up", label: "jump_up()", code: `jump_up();` },
            { id: "jump_down", label: "jump_down()", code: `jump_down();` },
            { id: "jump_left", label: "jump_left()", code: `jump_left();` },
            { id: "jump_right", label: "jump_right()", code: `jump_right();` },
            { id: "jump_left_up", label: "jump_left_up()", code: `jump_left_up();` },
            { id: "jump_left_down", label: "jump_left_down()", code: `jump_left_down();` },
            { id: "jump_right_up", label: "jump_right_up()", code: `jump_right_up();` },
            { id: "jump_right_down", label: "jump_right_down()", code: `jump_right_down();` },

            // ======== TURN ========
            { id: "turn", label: "turn(angle)", code: `turn(90);` },
            {
                id: "turn_right_or_left",
                label: "turn_right_or_left(direction)",
                code: `// direction = "RIGHT" ou "LEFT"\nturn_right_or_left("RIGHT");`,
            },
            {
                id: "choose_turn_angle",
                label: "choose_turn_angle(direction, angle)",
                code: `// direction = "RIGHT" ou "LEFT"\nchoose_turn_angle("LEFT", 45);`,
            },

            // ======== VARIABLES ========
            { id: "variable_walk", label: "variable_walk(distance)", code: `variable_walk(5);` },
            { id: "variable_jump", label: "variable_jump(height)", code: `variable_jump(2);` },
            { id: "variable_turn", label: "variable_turn(angle)", code: `variable_turn(120);` },
        ],
    },

    {
        name: "MouvementById",
        color: "#4096ff",
        snippets: [
            // ======== GÉNÉRAL ========
            { id: "mbid_walk", label: "walk_by_id(id)", code: `walk_by_id("charId");` },

            // ======== RELATIF ========
            {
                id: "mbid_walk_choice",
                label: "walk_choice_by_id(id, direction)",
                code: `// direction = "FORWARD" ou "BACKWARD"\nwalk_choice_by_id("charId", "FORWARD");`,
            },
            {
                id: "mbid_walk_choice_by_unit",
                label: "walk_choice_by_unit_by_id(id, direction, distance)",
                code: `// direction = "FORWARD" ou "BACKWARD"\nwalk_choice_by_unit_by_id("charId", "BACKWARD", 3);`,
            },

            // ======== AVANT / ARRIÈRE ========
            { id: "mbid_walk_forward", label: "walk_forward_by_id(id)", code: `walk_forward_by_id("charId");` },
            { id: "mbid_walk_backward", label: "walk_backward_by_id(id)", code: `walk_backward_by_id("charId");` },

            // ======== AXES CARDINAUX ========
            { id: "mbid_walk_up", label: "walk_up_by_id(id)", code: `walk_up_by_id("charId");` },
            { id: "mbid_walk_down", label: "walk_down_by_id(id)", code: `walk_down_by_id("charId");` },
            { id: "mbid_walk_left", label: "walk_left_by_id(id)", code: `walk_left_by_id("charId");` },
            { id: "mbid_walk_right", label: "walk_right_by_id(id)", code: `walk_right_by_id("charId");` },

            // ======== DIAGONALES ========
            { id: "mbid_walk_left_up", label: "walk_left_up_by_id(id)", code: `walk_left_up_by_id("charId");` },
            { id: "mbid_walk_left_down", label: "walk_left_down_by_id(id)", code: `walk_left_down_by_id("charId");` },
            { id: "mbid_walk_right_up", label: "walk_right_up_by_id(id)", code: `walk_right_up_by_id("charId");` },
            { id: "mbid_walk_right_down", label: "walk_right_down_by_id(id)", code: `walk_right_down_by_id("charId");` },

            // ======== JUMP ========
            { id: "mbid_jump", label: "jump_by_id(id, height)", code: `jump_by_id("charId", 1);` },
            {
                id: "mbid_jump_choice",
                label: "jump_choice_by_id(id, direction)",
                code: `// direction = "FORWARD" ou "BACKWARD"\njump_choice_by_id("charId", "FORWARD");`,
            },
            {
                id: "mbid_jump_choice_by_unit",
                label: "jump_choice_by_unit_by_id(id, direction, distance)",
                code: `// direction = "FORWARD" ou "BACKWARD"\njump_choice_by_unit_by_id("charId", "BACKWARD", 2);`,
            },
            { id: "mbid_jump_forward", label: "jump_forward_by_id(id)", code: `jump_forward_by_id("charId");` },
            { id: "mbid_jump_backward", label: "jump_backward_by_id(id)", code: `jump_backward_by_id("charId");` },
            { id: "mbid_jump_up", label: "jump_up_by_id(id)", code: `jump_up_by_id("charId");` },
            { id: "mbid_jump_down", label: "jump_down_by_id(id)", code: `jump_down_by_id("charId");` },
            { id: "mbid_jump_left", label: "jump_left_by_id(id)", code: `jump_left_by_id("charId");` },
            { id: "mbid_jump_right", label: "jump_right_by_id(id)", code: `jump_right_by_id("charId");` },
            { id: "mbid_jump_left_up", label: "jump_left_up_by_id(id)", code: `jump_left_up_by_id("charId");` },
            { id: "mbid_jump_left_down", label: "jump_left_down_by_id(id)", code: `jump_left_down_by_id("charId");` },
            { id: "mbid_jump_right_up", label: "jump_right_up_by_id(id)", code: `jump_right_up_by_id("charId");` },
            { id: "mbid_jump_right_down", label: "jump_right_down_by_id(id)", code: `jump_right_down_by_id("charId");` },

            // ======== TURN ========
            { id: "mbid_turn", label: "turn_by_id(id, angle)", code: `turn_by_id("charId", 90);` },
            {
                id: "mbid_turn_right_or_left",
                label: "turn_right_or_left_by_id(id, direction)",
                code: `turn_right_or_left_by_id("charId", "RIGHT");`,
            },
            {
                id: "mbid_choose_turn_angle",
                label: "choose_turn_angle_by_id(id, direction, angle)",
                code: `choose_turn_angle_by_id("charId", "LEFT", 45);`,
            },

            // ======== VARIABLES DYNAMIQUES ========
            { id: "mbid_variable_walk", label: "variable_walk_by_id(id, distance)", code: `variable_walk_by_id("charId", 5);` },
            { id: "mbid_variable_jump", label: "variable_jump_by_id(id, height)", code: `variable_jump_by_id("charId", 2);` },
            { id: "mbid_variable_turn", label: "variable_turn_by_id(id, angle)", code: `variable_turn_by_id("charId", 120);` },
        ],
    },

    {
        name: "Action",
        color: "#fa541c",
        snippets: [
            // ======== PERSONNAGES ========
            {
                id: "addCharacter",
                label: "addCharacter(name, x, y)",
                code: `addCharacter("name", 200, 200);`,
            },
            {
                id: "addCharacterWithSize",
                label: "addCharacterWithSize(name, x, y, width, height)",
                code: `addCharacterWithSize("name", 200, 200, 50, 50);`,
            },
            // {
            //     id: "find_character",
            //     label: "find_character(id)",
            //     code: `// Récupère l'entité Character par son ID\nfind_character("charId");`,
            // },

            // ======== COMMUNICATION ========
            { id: "say", label: "say(message)", code: `say("Hello!");` },
            {
                id: "say_by_id",
                label: "say_by_id(id, message)",
                code: `// Fait parler un perso spécifique\nsay_by_id("charId", "Hello!");`,
            },

            // ======== AUTOPILOTE ========
            {
                id: "activate_autopilot",
                label: "activate_auto_pilot(id)",
                code: `// Démarre l'autopilote pour un perso\nactivate_auto_pilot("charId");`,
            },
            {
                id: "desactivate_autopilot",
                label: "desactivate_auto_pilot(id)",
                code: `// Arrête l'autopilote pour un perso\ndesactivate_auto_pilot("charId");`,
            },

            // ======== DÉPLACEMENT / TÉLÉPORTATION ========
            {
                id: "move_to",
                label: "move_to(id, x, y)",
                code: `// Téléporte un perso\nmove_to("charId", 100, 200);`,
            },

            // ======== TAILLE ========
            {
                id: "change_size",
                label: "changeSize(id, newWidth, newHeight)",
                code: `// Modifie la taille d'un perso\nchangeSize("charId", 64, 64);`,
            },

            { id: "set_win", label: "set_win()", code: `set_win();` },
        ],
    },

    {
        name: "Effects",
        color: "#faad14",
        snippets: [
            {
                id: "set_gravity",
                label: "set_gravity(enable, gravityY?)",
                code: `// Active ou désactive la gravité\n// enable = true | false\nset_gravity(true);`,
            },
        ],
    },

    {
        name: "Objets",
        color: "#52c41a",
        snippets: [
            // ======== CRÉATION / SUPPRESSION ========
            {
                id: "add_object",
                label: "addObject(name, x, y)",
                code: `// Crée un objet et retourne son ID\nconst id = addObject("name", 50, 50);`,
            },
            {
                id: "addObjectWithSize",
                label: "addObjectWithSize(name, x, y, width, height)",
                code: `addObjectWithSize("name", 100, 100, 50, 50);`,
            },
            {
                id: "add_pickable",
                label: "addPickable(name, x, y)",
                code: `const id = addPickable("name", 50, 50);`,
            },
            {
                id: "addPickableWithSize",
                label: "addPickableWithSize(name, x, y, width, height)",
                code: `addPickableWithSize("name", 100, 100, 50, 50);`,
            },
            {
                id: "add_decor",
                label: "addDecor(name, x, y)",
                code: `const id = addDecor("name", 50, 50);`,
            },
            {
                id: "addDecorWithSize",
                label: "addDecorWithSize(name, x, y, width, height)",
                code: `addDecorWithSize("name", 100, 100, 50, 50);`,
            },
            {
                id: "add_immovable",
                label: "addImmovable(name, x, y)",
                code: `const id = addImmovable("name", 50, 50);`,
            },
            {
                id: "addImmovableWithSize",
                label: "addImmovableWithSize(name, x, y, width, height)",
                code: `addImmovableWithSize("name", 100, 100, 50, 50);`,
            },
            {
                id: "add_pushable",
                label: "addPushable(name, x, y)",
                code: `const id = addPushable("name", 50, 50);`,
            },
            {
                id: "addPushableWithSize",
                label: "addPushableWithSize(name, x, y, width, height)",
                code: `addPushableWithSize("name", 100, 100, 50, 50);`,
            },
            {
                id: "destroy_object",
                label: "destroyObject(id)",
                code: `// Supprime l'objet\ndestroyObject(id);`,
            },

            // ======== TRANSFORMATION ========
            {
                id: "move_object",
                label: "moveObject(id, x, y)",
                code: `// Déplace l'objet existant\nmoveObject(id, 150, 150);`,
            },
            {
                id: "resize_object",
                label: "resizeObject(id, width, height)",
                code: `// Redimensionne l'objet\nresizeObject(id, 80, 120);`,
            },

            // ======== PICKABILITÉ ========
            {
                id: "activatePickable",
                label: "activatePickable(id)",
                code: `// Rend l'objet pickable\nactivatePickable(id);`,
            },
            {
                id: "activate_pick_order",
                label: "activatePickOrder(id, order)",
                code: `// Rend l'objet pickable avec l'ordre donné\nactivatePickOrder(id, 1);`,
            },
            {
                id: "desactivate_pick_order",
                label: "desactivatePickOrder(id)",
                code: `// Désactive complètement la pickabilité\ndesactivatePickOrder(id);`,
            },

            // ======== IMMOBILITÉ ========
            {
                id: "activate_immovable",
                label: "activateImmovable(id)",
                code: `// Verrouille l'objet en place \nactivateImmovable(id);`,
            },
            {
                id: "desactivate_immovable",
                label: "desactivateImmovable(id)",
                code: `// Rend à nouveau l'objet mobile\ndesactivateImmovable(id);`,
            },

            // ======== POUSSABILITÉ ========
            {
                id: "activate_pushable",
                label: "activatePushable(id)",
                code: `// Autorise le personnage à pousser l'objet\nactivatePushable(id);`,
            },
            {
                id: "desactivate_pushable",
                label: "desactivatePushable(id)",
                code: `// Interdit de pousser l'objet\ndesactivatePushable(id);`,
            },

            // ======== DÉCOR ========
            {
                id: "activate_decor",
                label: "activateDecor(id)",
                code: `// Activer le mode décor\nactivateDecor(id);`,
            },
            {
                id: "desactivate_decor",
                label: "desactivateDecor(id)",
                code: `// Retirer le mode décor\ndesactivateDecor(id);`,
            },

            // ======== REQUÊTE ========
            {
                id: "is_picked",
                label: "is_picked(id)",
                code: `// Teste si l’objet a déjà été ramassé\nis_picked("objectId");`,
            },
        ],
    },

    {
        name: "Sons",
        color: "#a0d911",
        snippets: [
            { id: "play_sound", label: "play_sound(name)", code: `play_sound("laser");` },
            { id: "stop_sound", label: "stop_sound(name)", code: `stop_sound("laser");` },
            // (les alias playSound/stopSound existent aussi au runtime)
        ],
    },

    {
        name: "Text",
        color: "#2f54eb",
        snippets: [
            // ======== CRÉATION / SUPPRESSION ========
            {
                id: "create_text",
                label: "create(content, x, y)",
                code: `// Crée un texte simple et retourne son ID\nconst id = create("Hello World", 100, 100);`,
            },
            {
                id: "create_text_full",
                label: "create_full(content, x, y, font, size, color, bgColor)",
                code: `// Crée un texte complet avec style\ncreate_full("Hello World", 100, 100, "Arial", 18, "#000000", "#ffffff");`,
            },
            {
                id: "destroy_text",
                label: "destroy(id)",
                code: `// Supprime le texte\ndestroy("txt1");`,
            },

            // ======== POSITION ========
            {
                id: "move_text",
                label: "move(id, x, y)",
                code: `// Déplace le texte\nmove("txt1", 150, 200);`,
            },

            // ======== CONTENU ========
            {
                id: "set_text_content",
                label: "set_content(id, newContent)",
                code: `// Remplace tout le contenu\nset_content("txt1", "Nouveau contenu");`,
            },
            {
                id: "add_text_content",
                label: "add_content(id, additionalText)",
                code: `// Ajoute du texte à la suite\nadd_content("txt1", " plus de texte");`,
            },
            {
                id: "replace_text_content",
                label: "replace_content(id, old, new)",
                code: `// Remplace une sous-chaîne\nreplace_content("txt1", "old", "new");`,
            },
            {
                id: "cut_text",
                label: "cut(id, start, end)",
                code: `// Coupe le texte entre start et end\ncut("txt1", 0, 5);`,
            },
            { id: "reverse_text", label: "reverse(id)", code: `reverse("txt1");` },
            { id: "to_uppercase", label: "to_uppercase(id)", code: `to_uppercase("txt1");` },
            { id: "to_lowercase", label: "to_lowercase(id)", code: `to_lowercase("txt1");` },

            // ======== STYLE ========
            { id: "set_text_font", label: "set_font(id, fontFamily)", code: `set_font("txt1", "Comic Sans MS");` },
            { id: "set_font_size", label: "set_font_size(id, fontSize)", code: `set_font_size("txt1", 20);` },
            { id: "set_text_color", label: "set_color(id, color)", code: `set_color("txt1", "#ff0000");` },
            {
                id: "set_text_bg_color",
                label: "set_background_color(id, bgColor)",
                code: `set_background_color("txt1", "#cccccc");`,
            },

            // ======== REQUÊTE / ANALYSE ========
            {
                id: "get_text_content",
                label: "get_content(id)",
                code: `// Récupère le contenu actuel du texte\nconst content = get_content("txt1");`,
            },
            {
                id: "find_word_position",
                label: "find_word_position(id, word)",
                code: `// Trouve la position d'un mot\nfind_word_position("txt1", "Hello");`,
            },
            {
                id: "replace_word",
                label: "replace_word(id, old, new)",
                code: `// Remplace un mot spécifique\nreplace_word("txt1", "old", "new");`,
            },
            {
                id: "count_text_length",
                label: "count_length(id)",
                code: `// Compte le nombre de caractères\ncount_length("txt1");`,
            },
            {
                id: "count_char_occurrences",
                label: "count_char_occurrences(id, char)",
                code: `// Compte les occurrences d'un caractère\ncount_char_occurrences("txt1", "a");`,
            },
        ],
    },

    {
        name: "Variables",
        color: "#13c2c2",
        snippets: [
            { id: "let_x", label: "let x = 0;", code: `let x = 0;` },
            { id: "const_message", label: 'const message = "Hello";', code: `const message = "Hello";` },
            { id: "update_x", label: "x = x + 1;", code: `x = x + 1;` },
            { id: "x_increment", label: "x++", code: `x++;` },
            { id: "x_decrement", label: "x--", code: `x--;` },
            { id: "x_plus_5", label: "x += 5", code: `x += 5;` },
            { id: "x_minus_3", label: "x -= 3", code: `x -= 3;` },
            { id: "console_log_x", label: "console.log(x)", code: `console.log(x);` },
        ],
    },

    {
        name: "Opérations",
        color: "#f5222d",
        snippets: [
            { id: "addition", label: "Addition (+)", code: `let somme = x + y;` },
            { id: "soustraction", label: "Soustraction (-)", code: `let diff = x - y;` },
            { id: "multiplication", label: "Multiplication (*)", code: `let prod = x * y;` },
            { id: "division", label: "Division (/)", code: `let quotient = x / y;` },
            { id: "modulo", label: "Modulo (%)", code: `let reste = x % y;` },
            { id: "and", label: "AND (&&)", code: `if (a > 0 && b > 0) {\n  // ...\n}` },
            { id: "or", label: "OR (||)", code: `if (a === 0 || b === 0) {\n  // ...\n}` },
            { id: "not", label: "NOT (!)", code: `if (!condition) {\n  // ...\n}` },
        ],
    },

    {
        name: "Structures conditionnelles",
        color: "#fa8c16",
        snippets: [
            { id: "if", label: "if", code: `if (condition) {\n  // instructions si vrai\n}` },
            { id: "if_else", label: "if / else", code: `if (condition) {\n  // si vrai\n} else {\n  // si faux\n}` },
            {
                id: "if_else_if_else",
                label: "if / else if / else",
                code: `if (cond1) {\n  // si cond1\n} else if (cond2) {\n  // si cond2\n} else {\n  // sinon\n}`,
            },
            {
                id: "switch",
                label: "switch",
                code: `switch (val) {\n  case 1:\n    // ...\n    break;\n  case 2:\n    // ...\n    break;\n  default:\n    // ...\n}`,
            },
        ],
    },

    {
        name: "Structures répétitives",
        color: "#eb2f96",
        snippets: [
            { id: "for", label: "for", code: `for (let i = 0; i < 5; i++) {\n  console.log("i =", i);\n}` },
            { id: "while", label: "while", code: `while (condition) {\n  // instructions\n}` },
            { id: "do_while", label: "do...while", code: `do {\n  // instructions\n} while (condition);` },
            { id: "for_of", label: "for...of (tableau)", code: `for (let item of tableau) {\n  console.log(item);\n}` },
        ],
    },

    {
        name: "Fonctions",
        color: "#9254de",
        snippets: [
            {
                id: "fn_simple",
                label: "function (simple)",
                code: `function maFonction() {\n  console.log("Fonction appelée");\n}`,
            },
            {
                id: "fn_param",
                label: "function (avec param)",
                code: `function addition(a, b) {\n  return a + b;\n}`,
            },
            {
                id: "fn_no_return",
                label: "function (sans return)",
                code: `function direBonjour(nom) {\n  console.log("Bonjour, " + nom);\n}`,
            },
            {
                id: "arrow_function",
                label: "arrow function",
                code: `const maFonction = (x) => {\n  console.log("Arrow function, x=", x);\n};`,
            },
            { id: "fn_call", label: "appel de fonction", code: `maFonction("Hello");` },
            { id: "fn_random", label: "random(min, max)", code: `const n = random(1, 10); // 1 ≤ n ≤ 10` },
        ],
    },

    {
        name: "Tableaux",
        color: "#722ed1",
        snippets: [
            { id: "let_empty_array", label: "let arr = []", code: `let arr = [];` },
            { id: "let_array_numbers", label: "let arr = [1, 2, 3]", code: `let arr = [1, 2, 3];` },
            { id: "push_array", label: "arr.push(4)", code: `arr.push(4);` },
            { id: "pop_array", label: "arr.pop()", code: `arr.pop();` },
            { id: "access_array", label: "arr[0]", code: `console.log(arr[0]);` },
            { id: "length_array", label: "arr.length", code: `console.log(arr.length);` },
        ],
    },

    {
        name: "Events",
        color: "#faad14",
        snippets: [
            {
                id: "on_keyPress_enter",
                label: "@on keyPress Enter",
                code: `@on("keyPress", "Enter"){\n  console.log("La touche Enter a été pressée");\n}`,
            },
            {
                id: "on_keyPress",
                label: "@on keyPress",
                code: `@on("keyPress", "w", "d", "a", "s"){
  if (key === "w") {
    walk_up();       // W → Up
  } else if (key === "d") {
    walk_right();    // D → Right
  } else if (key === "a") {
    walk_left();     // A → Left
  } else if (key === "s") {
    walk_down();     // S → Down
  }
}`,
            },

            { id: "on_collision", label: "@on collision", code: `@on("collision"){\n  console.log("Collision détectée");\n}` },
            {
                id: "timer_once",
                label: "timer_once(sec)",
                code: `@on("timerOnce", 5){
  // ton code ici (se déclenche une fois après 5 s)
}`,
            },
            {
                id: "timer_during",
                label: "timer_during(sec)",
                code: `@on("timerDuring", 1){
  // ton code ici (toutes les 1 s jusqu’à arrêt)
}`,
            },
            {
                id: "on_text_change",
                label: '@on("textChange", "txt1"){ ... }',
                code: `@on("textChange","txt1"){
  // ev.textId, ev.newText, ev.oldText disponibles
  say("Le texte a changé !");
}`,
            },
            {
                id: "on_pickup_any",
                label: '@on("pickup"){ ... }   // n’importe quel ramassage',
                code: `@on("pickup"){
  // déclenché pour tout objet ramassé par n'importe quel perso
}`,
            },
            {
                id: "on_pickup_obj",
                label: '@on("pickup","key01"){ ... }   // filtre sur l’objet',
                code: `@on("pickup","key01"){
  console.log("Quelqu’un a ramassé la clé !");
}`,
            },
        ],
    },
];
